import React from "react";
import readValue from "./value";

export default function render(value, accessor, tuple) {
    return readValue(value, accessor, tuple);
}